import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
    root: {
        maxWidth: theme.breakpoints.values.lg
    },
    taskList: {
        marginBottom: 52
    },
    focusThresholds: {
        marginBottom: 48
    },
    heading: {
        marginBottom: 8
    },
    subheading: {
        marginBottom: 24
    },
}));